var map = {
	"./angry-red.png": 1899,
	"./angry.png": 1900,
	"./anguished.png": 1901,
	"./anxious.png": 1902,
	"./beaming-face.png": 1903,
	"./confounded-normal.png": 1904,
	"./confounded.png": 1905,
	"./confused.png": 1906,
	"./crying-loudly.png": 1907,
	"./crying.png": 1908,
	"./devil.png": 1909,
	"./disappointed.png": 1910,
	"./distraught.png": 1911,
	"./dizzy.png": 1912,
	"./downcast.png": 1913,
	"./expressionless.png": 1914,
	"./fearful.png": 1915,
	"./frowning-eyebrows.png": 1916,
	"./frowning.png": 1917,
	"./grimacing.png": 1918,
	"./grinning-smiling-eyes.png": 1919,
	"./grinning-smiling-squinting-eyes.png": 1920,
	"./grinning.png": 1921,
	"./hand-1.png": 1922,
	"./hand-2.png": 1923,
	"./hand-3.png": 1924,
	"./hand-4.png": 1925,
	"./hand-5.png": 1926,
	"./inlove.png": 1927,
	"./innocent.png": 1928,
	"./kissing-closed-eyes.png": 1929,
	"./kissing.png": 1930,
	"./laughing.png": 1931,
	"./mask.png": 1932,
	"./neutral.png": 1933,
	"./persevering.png": 1934,
	"./relieved.png": 1935,
	"./sad.png": 1936,
	"./screaming.png": 1937,
	"./shy.png": 1938,
	"./sleepy.png": 1939,
	"./smile-licky.png": 1940,
	"./smile.png": 1941,
	"./smirk.png": 1942,
	"./smoked.png": 1943,
	"./steamy.png": 1944,
	"./stick-out-tongue.png": 1945,
	"./sunglasses.png": 1946,
	"./surprised.png": 1947,
	"./tongue-out.png": 1948,
	"./unamused.png": 1949,
	"./weary.png": 1950,
	"./wink-licky.png": 1951,
	"./wink.png": 1952,
	"./without-mouth.png": 1953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2161;